import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Col,
  Spinner,
  Alert,
  Row,
  Button,
  ButtonGroup,
  Dropdown,
  DropdownButton,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import Steps, { Step } from "rc-steps";
import "rc-steps/assets/index.css";
import "rc-steps/assets/iconfont.css";
import { Link, useHistory } from "react-router-dom";
import toastr from "toastr";

import CustomNavbar from "../../../components/CustomNavbar";
import SidebarConfig from "../../../components/SidebarDashboard";

import { getBienvenidaPorUsuario } from "../../../redux/on&offBoarning/Mantenimientos/bienvenida/actions";

import { getCapacitaciones } from "../../../redux/on&offBoarning/capacitacion/actions";

const Bienvenida = (props) => {
  const [show, setShow] = useState(false);
  const [current, setCurrent] = useState(0);

  const userN = useSelector((store) => store.auth.name);
  const cEmp = useSelector((store) => store.auth.username);
  const userId = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);
  const onShowSidebar = () => setShow(show ? false : true);

  const dispatch = useDispatch();
  const history = useHistory();

  const { bienvenidaEmp, loadingBienvenidaEmp } = useSelector(
    (store) => store.bienvenida
  );

  const { capacitacionList, capacitacionListLength, loadingList } = useSelector(
    (store) => store.capacitacion
  );

  useEffect(() => {
    if (cEmp !== "") {
      dispatch(getCapacitaciones({ filter: cEmp, tipo_busqueda: "empleado", tipo_workflow: "[1]",}));
    }
  }, [dispatch, cEmp]);

  useEffect(() => {
    if (cEmp && userId && userType) {
      if (parseInt(props.match.params.tipoWorkflow) === 1) {
        dispatch(getBienvenidaPorUsuario({ cempleado: cEmp }));
      } else {
        history.push(`/detalle-empleado/${userId}/${userType}`);
      }
    }
  }, [dispatch, props.match.params, cEmp]);

  const renderSwitch = (param) => {
    switch (param.type) {
      case "paragraph":
        return (
          <p
            style={{
              textAlign: `${param.data.alignment}`,
            }}
            dangerouslySetInnerHTML={{ __html: param.data.text }}
          />
        );
      case "header":
        switch (param.data.level) {
          case 1:
            return (
              <h1
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 2:
            return (
              <h2
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 3:
            return (
              <h3
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 4:
            return (
              <h4
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 5:
            return (
              <h5
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 6:
            return (
              <h6
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          default:
            return null;
        }
      case "breakLine":
        return <br />;
      default:
        return null;
    }
  };

  return (
    <>
      <CustomNavbar onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          {/* <OnBoardingNavMenu opcion="IN" /> */}
          <Col md="12" className="mx-auto mt-4">
            <Row className="d-flex justify-content-between align-items-center flex-nowrap">
              <Col xs="auto" className="px-3">
                <h4 className="font-weight-bold text-uppercase m-0">
                  Capacitación
                </h4>
              </Col>
              {/* <Col xs="auto">
                <Dropdown size="sm">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip {...props}>Proceso de Capacitación</Tooltip>
                    }
                  >
                    <Dropdown.Toggle
                      as={ButtonGroup}
                      variant="secondary"
                      className="btn btn-primary rounded flex-wrap justify-content-center align-items-center"
                    >
                      <i className="material-icons">reorder</i>
                    </Dropdown.Toggle>
                  </OverlayTrigger>
                  <Dropdown.Menu
                    className="pb-0 pt-0 shadow-sm"
                    style={{
                      width: "16rem",
                      transition: "all 0.2s",
                    }}
                  >
                    <h6
                      className="tituloProceso text-muted font-weight-bold text-uppercase pl-1 pb-2 pt-3 rounded d-flex flex-wrap justify-content-center align-items-center"
                      style={{ borderBottom: "1px solid rgb(235, 237, 240)" }}
                    >
                      Proceso de Capacitación
                    </h6>
                    {loadingList ? (
                      <div className="d-flex justify-content-center">
                        <Spinner
                          animation="border"
                          role="status"
                          className="d-flex justify-content-center"
                        />
                      </div>
                    ) : capacitacionList && capacitacionListLength === 0 ? (
                      <Alert
                        variant="info"
                        className="my-4 ml-3 mr-3 d-flex flex-wrap justify-content-start align-items-center"
                      >
                        <i className="material-icons mx-3">info</i>
                        No tiene seguimiento asignados, para mas información
                        contactar al administrador.
                      </Alert>
                    ) : capacitacionList && capacitacionListLength > 0 ? (
                      <Steps
                        style={{
                          // border: "1px solid rgb(235, 237, 240)",
                          overflowY: "auto",
                          maxHeight: "18rem",
                        }}
                        // className="shadow-sm rounded"
                        className="p-3"
                        direction="vertical"
                        // type="navigation"
                        current={current}
                        // status="error"
                        // status="process"
                        // status="finish"
                        // status="wait"
                      >
                        {capacitacionList.map((item, index) => (
                          <Step
                            title={item.nombre}
                            className="paso"
                            onClick={() => {
                              history.push(
                                `/capacitacion/${item.nombre.toLocaleLowerCase()}/${
                                  item.id
                                }/${index}`
                              );
                            }}
                            status="process"
                          />
                        ))}
                      </Steps>
                    ) : null}
                  </Dropdown.Menu>
                </Dropdown>
              </Col> */}
              <OverlayTrigger
                placement="left"
                overlay={
                  <Tooltip {...props}>
                    Avanzar a {props.match.params.name}
                  </Tooltip>
                }
              >
                <Button
                  variant="primary"
                  size="md"
                  className="btn shadow-sm rounded mr-3"
                  onClick={() => {
                    history.push(
                      `/capacitacion/${props.match.params.name}/${parseInt(
                        props.match.params.id
                      )}/${parseInt(props.match.params.tipoWorkflow)}/${
                        props.match.params.type
                      }`
                    );
                  }}
                >
                  <p className="m-0 d-flex">
                    Avanzar
                    <i className="material-icons ml-2">skip_next</i>
                  </p>
                </Button>
              </OverlayTrigger>
            </Row>
          </Col>
          <div className="px-3 shadow-sm">
            <hr />
          </div>
          <Col
            className="mb-5 ml-auto mr-auto"
            xs="10"
            sm="10"
            md="9"
            lg="9"
            xl="9"
          >
            <Col
              className="mb-1 mt-4 mr-auto bg-white p-0"
              // style={{ border: "1px solid rgb(235, 237, 240)" }}
            >
              <h5 className="font-weight-bold text-uppercase m-0 ml-3 d-flex">
                {/* <i className="material-icons mr-2">waving_hand</i> */}
                Bienvenido(a) {userN}
              </h5>
            </Col>
            <div className="shadow-sm">
              <hr />
            </div>
            <Col
              className="shadow-sm p-3 bg-white rounded"
              style={{ border: "1px solid #ced4da" }}
            >
              {loadingBienvenidaEmp ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : bienvenidaEmp && bienvenidaEmp.length === 0 ? (
                <Alert variant="info" className="my-4">
                  No existe una carta de bienvenida, para mas información
                  contactar a su jefe inmediato.
                </Alert>
              ) : (
                <div className="p-3 bg-white">
                  {bienvenidaEmp.map((item) => renderSwitch(item))}
                </div>
              )}
            </Col>
          </Col>
        </Container>
      </div>
    </>
  );
};

export default Bienvenida;
